module.exports = __webpack_public_path__ + "static/media/rb.6e13da59.png";